export default "__VITE_ASSET__BXCoPlC4__"